module.exports = __webpack_public_path__ + "img/moreGameIcon.0660cf85.svg";